const eeDashboardReport = "EEDashboardReport";
export const SearchDashboardReports = `/${eeDashboardReport}/SearchDashboardReports`;
export const DeleteReport = `/${eeDashboardReport}/DeleteReport`;
export const DownloadReport = `/${eeDashboardReport}/DownloadReport`;
export const GenerateReport = `/${eeDashboardReport}/GenerateEEPowerPointReport`;